var _path, _ellipse, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedinDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.98867 11.4165H3.01089C2.66725 11.4165 2.38867 11.6951 2.38867 12.0387V28.8776C2.38867 29.2213 2.66725 29.4998 3.01089 29.4998H7.98867C8.33232 29.4998 8.6109 29.2213 8.6109 28.8776V12.0387C8.6109 11.6951 8.33232 11.4165 7.98867 11.4165Z",
    stroke: "white",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.5,
    cy: 5.58317,
    rx: 3.5,
    ry: 2.91666,
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.7498 11.7668V13.7501C20.6665 8.50007 29.9998 10.8334 29.9998 17.8334V28.9167C29.9998 29.2389 29.7387 29.5001 29.4165 29.5001L24.7498 29.5001C24.4277 29.5001 24.1665 29.2389 24.1665 28.9167V19.0001C24.1665 17.8334 22.9218 15.5001 20.6665 15.5001C18.4112 15.5001 17.7498 17.8334 17.7498 19.0001V28.9167C17.7498 29.2389 17.4887 29.5001 17.1665 29.5001H12.4998C12.1777 29.5001 11.9165 29.2389 11.9165 28.9167V11.7668C11.9165 11.5735 12.0732 11.4168 12.2665 11.4168H17.3998C17.5931 11.4168 17.7498 11.5735 17.7498 11.7668Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedinDark);
export default __webpack_public_path__ + "static/media/linkedinDark.a7d6e632a777bc1658d019e6c9f39980.svg";
export { ForwardRef as ReactComponent };